/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Injury_Content_Callout_0_LabelInputs */

const en_injury_content_callout_0_label = /** @type {(inputs: Injury_Content_Callout_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beginners`)
};

const es_injury_content_callout_0_label = /** @type {(inputs: Injury_Content_Callout_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Principiantes`)
};

const de_injury_content_callout_0_label = /** @type {(inputs: Injury_Content_Callout_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anfänger`)
};

const zh_injury_content_callout_0_label = /** @type {(inputs: Injury_Content_Callout_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`初学者`)
};

const ar_injury_content_callout_0_label = /** @type {(inputs: Injury_Content_Callout_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المبتدئون`)
};

const fr_injury_content_callout_0_label = /** @type {(inputs: Injury_Content_Callout_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Débutants`)
};

const vi_injury_content_callout_0_label = /** @type {(inputs: Injury_Content_Callout_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Người mới`)
};

const sw_injury_content_callout_0_label = /** @type {(inputs: Injury_Content_Callout_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wanaoanza`)
};

const th_injury_content_callout_0_label = /** @type {(inputs: Injury_Content_Callout_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`มือใหม่`)
};

const bs_injury_content_callout_0_label = /** @type {(inputs: Injury_Content_Callout_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Početnici`)
};

const ja_injury_content_callout_0_label = /** @type {(inputs: Injury_Content_Callout_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`初心者`)
};

const ko_injury_content_callout_0_label = /** @type {(inputs: Injury_Content_Callout_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`초보자`)
};

const pt_injury_content_callout_0_label = /** @type {(inputs: Injury_Content_Callout_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciantes`)
};

const it_injury_content_callout_0_label = /** @type {(inputs: Injury_Content_Callout_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Principianti`)
};

const sv_injury_content_callout_0_label = /** @type {(inputs: Injury_Content_Callout_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nybörjare`)
};

const nl_injury_content_callout_0_label = /** @type {(inputs: Injury_Content_Callout_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beginners`)
};

const da_injury_content_callout_0_label = /** @type {(inputs: Injury_Content_Callout_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Begyndere`)
};

const nb_injury_content_callout_0_label = /** @type {(inputs: Injury_Content_Callout_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nybegynnere`)
};

const fi_injury_content_callout_0_label = /** @type {(inputs: Injury_Content_Callout_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aloittelijat`)
};

const pl_injury_content_callout_0_label = /** @type {(inputs: Injury_Content_Callout_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Początkujący`)
};

const ru_injury_content_callout_0_label = /** @type {(inputs: Injury_Content_Callout_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начинающие`)
};

const tr_injury_content_callout_0_label = /** @type {(inputs: Injury_Content_Callout_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yeni başlayanlar`)
};

const hi_injury_content_callout_0_label = /** @type {(inputs: Injury_Content_Callout_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शुरुआती खिलाड़ी`)
};

const id_injury_content_callout_0_label = /** @type {(inputs: Injury_Content_Callout_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemula`)
};

const ms_injury_content_callout_0_label = /** @type {(inputs: Injury_Content_Callout_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemula`)
};

const cs_injury_content_callout_0_label = /** @type {(inputs: Injury_Content_Callout_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Začátečníci`)
};

const el_injury_content_callout_0_label = /** @type {(inputs: Injury_Content_Callout_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Αρχάριοι`)
};

const he_injury_content_callout_0_label = /** @type {(inputs: Injury_Content_Callout_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מתחילים`)
};

const af_injury_content_callout_0_label = /** @type {(inputs: Injury_Content_Callout_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beginners`)
};

const hu_injury_content_callout_0_label = /** @type {(inputs: Injury_Content_Callout_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kezdők`)
};

/**
* | output |
* | --- |
* | "Beginners" |
*
* @param {Injury_Content_Callout_0_LabelInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const injury_content_callout_0_label = /** @type {((inputs?: Injury_Content_Callout_0_LabelInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Injury_Content_Callout_0_LabelInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_injury_content_callout_0_label(inputs)
	if (locale === "de") return de_injury_content_callout_0_label(inputs)
	if (locale === "zh") return zh_injury_content_callout_0_label(inputs)
	if (locale === "ar") return ar_injury_content_callout_0_label(inputs)
	if (locale === "fr") return fr_injury_content_callout_0_label(inputs)
	if (locale === "vi") return vi_injury_content_callout_0_label(inputs)
	if (locale === "sw") return sw_injury_content_callout_0_label(inputs)
	if (locale === "th") return th_injury_content_callout_0_label(inputs)
	if (locale === "bs") return bs_injury_content_callout_0_label(inputs)
	if (locale === "ja") return ja_injury_content_callout_0_label(inputs)
	if (locale === "ko") return ko_injury_content_callout_0_label(inputs)
	if (locale === "pt") return pt_injury_content_callout_0_label(inputs)
	if (locale === "it") return it_injury_content_callout_0_label(inputs)
	if (locale === "sv") return sv_injury_content_callout_0_label(inputs)
	if (locale === "nl") return nl_injury_content_callout_0_label(inputs)
	if (locale === "da") return da_injury_content_callout_0_label(inputs)
	if (locale === "nb") return nb_injury_content_callout_0_label(inputs)
	if (locale === "fi") return fi_injury_content_callout_0_label(inputs)
	if (locale === "pl") return pl_injury_content_callout_0_label(inputs)
	if (locale === "ru") return ru_injury_content_callout_0_label(inputs)
	if (locale === "tr") return tr_injury_content_callout_0_label(inputs)
	if (locale === "hi") return hi_injury_content_callout_0_label(inputs)
	if (locale === "id") return id_injury_content_callout_0_label(inputs)
	if (locale === "ms") return ms_injury_content_callout_0_label(inputs)
	if (locale === "cs") return cs_injury_content_callout_0_label(inputs)
	if (locale === "el") return el_injury_content_callout_0_label(inputs)
	if (locale === "he") return he_injury_content_callout_0_label(inputs)
	if (locale === "af") return af_injury_content_callout_0_label(inputs)
	if (locale === "hu") return hu_injury_content_callout_0_label(inputs)
	return en_injury_content_callout_0_label(inputs)
});